import { IUploadInfo } from "views/bulkUpload/UploadCatalog/content/uploadCatalogInfo";

export const downloadUploadSummary = (uploadedRecords: number, totalRecords: number): IUploadInfo => ({
  title: 'Tu plantilla ha sido cargada',
  description: (
    <>
      Se subieron{' '}
      <strong>
        {uploadedRecords} de {totalRecords} órdenes correctamente.
      </strong>{' '}
      Ahora puedes volver al Cargue masivo para realizar otro cargue o ir a Órdenes para revisar las órdenes cargadas.
    </>
  ),
  icon: 'document'
});

export const downloadUploadSummaryWithErrors = (
  uploadedRecords: number,
  totalRecords: number,
  templateUrl: string
): IUploadInfo => ({
  title: 'Revisa y confirma la información',
  description: (
    <>
      Se subieron <strong>{uploadedRecords} de {totalRecords} órdenes.</strong> Algunas órdenes no pudieron subirse por errores
    </>
  ),
  icon: 'document'
});
